module.exports = __webpack_public_path__ + "img/bus.d6508106.svg";